import { GatsbyImage } from "gatsby-plugin-image"
import Link from "./link"
import React from "react"

const MoreArticles = ({ articles, isJournal=false }) => {
  return (
    <div className='story--moreArticles p40 ml60'>
      <div className='bt1 mb40' />
      <h4 className='h4 mb60'>Read More</h4>
      <div className='grid'>
        {articles?.map(article => (
          <Article key={article?.id || article?.slug} isJournal={isJournal} title={article?.name} caption={article?.caption} image={article?.image} slug={article?.slug} />
        ))}
      </div>
    </div>
  )
}

export default MoreArticles

const Article = ({ title, caption, image, slug, isJournal }) => {
  return (
    <>
      <div className='grid overflow m-gap-20'>
        <Link to={`/guide/${slug}`} className='w-100 flex image--zoom'>
          <div className='overflow w-100 ratio-2-1 pos-rel'>
            <GatsbyImage image={image?.gatsbyImageData} alt='' className='bg-image ' />
          </div>
        </Link>
        <div className='br1 pr40 max-450 mt10 m-b0 m-bb1 m-pb40 m-max-auto m-100 flex flex-column'>
          <h5 className='m0 h6'>{title}</h5>
          <p className='h5 text-sm mb40'>{caption}</p>
          <div className='mta'>
            <Link to={`/guide/${slug}`}>
              <button className='button w-100 max-200 mta'>Read More</button>
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
